import * as i0 from '@angular/core';
import * as i1 from './app.module';
import * as i2 from '@angular/common';
import * as i3 from '@ngx-translate/core/src/translate.directive';
import * as i4 from '@angular/forms';
import * as i5 from 'ngx-paypal';
import * as i6 from '@angular/material/expansion';
import * as i7 from '@angular/cdk/bidi';
import * as i8 from '@angular/material/checkbox';
import * as i9 from 'ngx-clipboard/dist/src/clipboard.directive';
import * as i10 from '@angular/material/button';
import * as i11 from '@swimlane/ngx-datatable/release/components/datatable.component';
import * as i12 from '@swimlane/ngx-datatable/release/components/row-detail/row-detail.directive';
import * as i13 from '@swimlane/ngx-datatable/release/components/body/body-group-header.directive';
import * as i14 from '@swimlane/ngx-datatable/release/components/row-detail/row-detail-template.directive';
import * as i15 from '@swimlane/ngx-datatable/release/components/columns/column.directive';
import * as i16 from '@swimlane/ngx-datatable/release/components/columns/column-header.directive';
import * as i17 from '@swimlane/ngx-datatable/release/components/columns/column-cell.directive';
import * as i18 from '@swimlane/ngx-datatable/release/components/footer/footer-template.directive';
import * as i19 from '@swimlane/ngx-datatable/release/components/footer/footer.directive';
import * as i20 from '@swimlane/ngx-datatable/release/components/footer/pager.component';
import * as i21 from '@swimlane/ngx-datatable/release/components/body/body-group-header-template.directive';
import * as i22 from '@angular/material/form-field';
import * as i23 from '@angular/material/core';
import * as i24 from '@angular/material/select';
import * as i25 from 'tree-ngx';
import * as i26 from '@angular/material/icon';
import * as i27 from '@angular/material/radio';
import * as i28 from '@angular/material/input';
import * as i29 from '@angular/flex-layout/flex';
import * as i30 from '@angular/flex-layout/extended';
import * as i31 from '@angular/material/menu';
import * as i32 from '@angular/router';
import * as i33 from './app.component';
import * as i34 from './about/about.component';
import * as i35 from './sysreq/sysreq.component';
import * as i36 from './admin/admin.component';
import * as i37 from './pp/pp.component';
import * as i38 from './admin/invoices/invoices.component';
import * as i39 from './admin/map-editor/map-editor.component';
import * as i40 from './admin/keys/keys.component';
import * as i41 from './getZinc/getZinc.component';
import * as i42 from './no-content/no-content.component';
import * as i43 from './changelog/changelog.component';
import * as i44 from './maps/maps.component';
import * as i45 from './pro/pro.component';
import * as i46 from './user/login/login.component';
import * as i47 from '@ngx-translate/core/src/translate.pipe';
import * as i48 from '@angular/platform-browser';
import * as i49 from '@ngx-translate/core/index';
import * as i50 from '@angular/platform-browser/animations';
import * as i51 from '@angular/cdk/layout';
import * as i52 from 'ngx-clipboard/dist/src/ngx-clipboard';
import * as i53 from '@swimlane/ngx-datatable/release/datatable.module';
import * as i54 from '@angular/flex-layout';
import * as i55 from '@angular/common/http';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.TranslateDirective = (<any>(null as any));
var _decl0_12:i4.ɵbf = (<any>(null as any));
var _decl0_13:i4.NgSelectOption = (<any>(null as any));
var _decl0_14:i4.ɵq = (<any>(null as any));
var _decl0_15:i4.DefaultValueAccessor = (<any>(null as any));
var _decl0_16:i4.ɵbc = (<any>(null as any));
var _decl0_17:i4.ɵbe = (<any>(null as any));
var _decl0_18:i4.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_19:i4.SelectControlValueAccessor = (<any>(null as any));
var _decl0_20:i4.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_21:i4.RadioControlValueAccessor = (<any>(null as any));
var _decl0_22:i4.NgControlStatus = (<any>(null as any));
var _decl0_23:i4.NgControlStatusGroup = (<any>(null as any));
var _decl0_24:i4.RequiredValidator = (<any>(null as any));
var _decl0_25:i4.MinLengthValidator = (<any>(null as any));
var _decl0_26:i4.MaxLengthValidator = (<any>(null as any));
var _decl0_27:i4.PatternValidator = (<any>(null as any));
var _decl0_28:i4.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_29:i4.EmailValidator = (<any>(null as any));
var _decl0_30:i4.NgModel = (<any>(null as any));
var _decl0_31:i4.NgModelGroup = (<any>(null as any));
var _decl0_32:i4.NgForm = (<any>(null as any));
var _decl0_33:i4.FormControlDirective = (<any>(null as any));
var _decl0_34:i4.FormGroupDirective = (<any>(null as any));
var _decl0_35:i4.FormControlName = (<any>(null as any));
var _decl0_36:i4.FormGroupName = (<any>(null as any));
var _decl0_37:i4.FormArrayName = (<any>(null as any));
var _decl0_38:i5.NgxPaypalComponent = (<any>(null as any));
var _decl0_39:i6.MatAccordion = (<any>(null as any));
var _decl0_40:i6.MatExpansionPanel = (<any>(null as any));
var _decl0_41:i6.MatExpansionPanelActionRow = (<any>(null as any));
var _decl0_42:i6.MatExpansionPanelHeader = (<any>(null as any));
var _decl0_43:i6.MatExpansionPanelTitle = (<any>(null as any));
var _decl0_44:i6.MatExpansionPanelDescription = (<any>(null as any));
var _decl0_45:i6.MatExpansionPanelContent = (<any>(null as any));
var _decl0_46:i7.Dir = (<any>(null as any));
var _decl0_47:i8.MatCheckbox = (<any>(null as any));
var _decl0_48:i8.MatCheckboxRequiredValidator = (<any>(null as any));
var _decl0_49:i9.ClipboardDirective = (<any>(null as any));
var _decl0_50:i10.MatButton = (<any>(null as any));
var _decl0_51:i10.MatAnchor = (<any>(null as any));
var _decl0_52:i10.MatMiniFab = (<any>(null as any));
var _decl0_53:i10.MatFab = (<any>(null as any));
var _decl0_54:i10.MatButtonCssMatStyler = (<any>(null as any));
var _decl0_55:i10.MatRaisedButtonCssMatStyler = (<any>(null as any));
var _decl0_56:i10.MatIconButtonCssMatStyler = (<any>(null as any));
var _decl0_57:i11.DatatableComponent = (<any>(null as any));
var _decl0_58:i12.DatatableRowDetailDirective = (<any>(null as any));
var _decl0_59:i13.DatatableGroupHeaderDirective = (<any>(null as any));
var _decl0_60:i14.DatatableRowDetailTemplateDirective = (<any>(null as any));
var _decl0_61:i15.DataTableColumnDirective = (<any>(null as any));
var _decl0_62:i16.DataTableColumnHeaderDirective = (<any>(null as any));
var _decl0_63:i17.DataTableColumnCellDirective = (<any>(null as any));
var _decl0_64:i18.DataTableFooterTemplateDirective = (<any>(null as any));
var _decl0_65:i19.DatatableFooterDirective = (<any>(null as any));
var _decl0_66:i20.DataTablePagerComponent = (<any>(null as any));
var _decl0_67:i21.DatatableGroupHeaderTemplateDirective = (<any>(null as any));
var _decl0_68:i22.MatError = (<any>(null as any));
var _decl0_69:i22.MatHint = (<any>(null as any));
var _decl0_70:i22.MatFormField = (<any>(null as any));
var _decl0_71:i22.MatPlaceholder = (<any>(null as any));
var _decl0_72:i22.MatPrefix = (<any>(null as any));
var _decl0_73:i22.MatSuffix = (<any>(null as any));
var _decl0_74:i22.MatLabel = (<any>(null as any));
var _decl0_75:i23.MatOption = (<any>(null as any));
var _decl0_76:i23.MatOptgroup = (<any>(null as any));
var _decl0_77:i24.MatSelect = (<any>(null as any));
var _decl0_78:i24.MatSelectTrigger = (<any>(null as any));
var _decl0_79:i25.TreeNgxComponent = (<any>(null as any));
var _decl0_80:i26.MatIcon = (<any>(null as any));
var _decl0_81:i27.MatRadioGroup = (<any>(null as any));
var _decl0_82:i27.MatRadioButton = (<any>(null as any));
var _decl0_83:i28.MatInput = (<any>(null as any));
var _decl0_84:i28.MatTextareaAutosize = (<any>(null as any));
var _decl0_85:i29.LayoutDirective = (<any>(null as any));
var _decl0_86:i29.LayoutGapDirective = (<any>(null as any));
var _decl0_87:i29.LayoutAlignDirective = (<any>(null as any));
var _decl0_88:i29.FlexDirective = (<any>(null as any));
var _decl0_89:i29.FlexOrderDirective = (<any>(null as any));
var _decl0_90:i29.FlexOffsetDirective = (<any>(null as any));
var _decl0_91:i29.FlexFillDirective = (<any>(null as any));
var _decl0_92:i29.FlexAlignDirective = (<any>(null as any));
var _decl0_93:i30.ShowHideDirective = (<any>(null as any));
var _decl0_94:i30.ClassDirective = (<any>(null as any));
var _decl0_95:i30.StyleDirective = (<any>(null as any));
var _decl0_96:i30.ImgSrcDirective = (<any>(null as any));
var _decl0_97:i31.MatMenu = (<any>(null as any));
var _decl0_98:i31.MatMenuItem = (<any>(null as any));
var _decl0_99:i31.MatMenuTrigger = (<any>(null as any));
var _decl0_100:i32.RouterOutlet = (<any>(null as any));
var _decl0_101:i32.RouterLink = (<any>(null as any));
var _decl0_102:i32.RouterLinkWithHref = (<any>(null as any));
var _decl0_103:i32.RouterLinkActive = (<any>(null as any));
var _decl0_104:i33.AppComponent = (<any>(null as any));
var _decl0_105:i34.AboutComponent = (<any>(null as any));
var _decl0_106:i35.SysreqComponent = (<any>(null as any));
var _decl0_107:i36.AdminComponent = (<any>(null as any));
var _decl0_108:i37.PaypalComponent = (<any>(null as any));
var _decl0_109:i38.InvoicesComponent = (<any>(null as any));
var _decl0_110:i39.MapEditorComponent = (<any>(null as any));
var _decl0_111:i40.KeysComponent = (<any>(null as any));
var _decl0_112:i41.GetZincComponent = (<any>(null as any));
var _decl0_113:i42.NoContentComponent = (<any>(null as any));
var _decl0_114:i43.ChangelogComponent = (<any>(null as any));
var _decl0_115:i44.MapsComponent = (<any>(null as any));
var _decl0_116:i45.ProComponent = (<any>(null as any));
var _decl0_117:i46.LoginComponent = (<any>(null as any));
var _decl0_118:i2.AsyncPipe = (<any>(null as any));
var _decl0_119:i2.UpperCasePipe = (<any>(null as any));
var _decl0_120:i2.LowerCasePipe = (<any>(null as any));
var _decl0_121:i2.JsonPipe = (<any>(null as any));
var _decl0_122:i2.SlicePipe = (<any>(null as any));
var _decl0_123:i2.DecimalPipe = (<any>(null as any));
var _decl0_124:i2.PercentPipe = (<any>(null as any));
var _decl0_125:i2.TitleCasePipe = (<any>(null as any));
var _decl0_126:i2.CurrencyPipe = (<any>(null as any));
var _decl0_127:i2.DatePipe = (<any>(null as any));
var _decl0_128:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_129:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_130:i47.TranslatePipe = (<any>(null as any));
var _decl0_131:i48.BrowserModule = (<any>(null as any));
var _decl0_132:i49.TranslateModule = (<any>(null as any));
var _decl0_133:i50.BrowserAnimationsModule = (<any>(null as any));
var _decl0_134:i4.FormsModule = (<any>(null as any));
var _decl0_135:i4.ReactiveFormsModule = (<any>(null as any));
var _decl0_136:i51.LayoutModule = (<any>(null as any));
var _decl0_137:i5.NgxPayPalModule = (<any>(null as any));
var _decl0_138:i6.MatExpansionModule = (<any>(null as any));
var _decl0_139:i8.MatCheckboxModule = (<any>(null as any));
var _decl0_140:i52.ClipboardModule = (<any>(null as any));
var _decl0_141:i10.MatButtonModule = (<any>(null as any));
var _decl0_142:i53.NgxDatatableModule = (<any>(null as any));
var _decl0_143:i24.MatSelectModule = (<any>(null as any));
var _decl0_144:i25.TreeNgxModule = (<any>(null as any));
var _decl0_145:i26.MatIconModule = (<any>(null as any));
var _decl0_146:i27.MatRadioModule = (<any>(null as any));
var _decl0_147:i22.MatFormFieldModule = (<any>(null as any));
var _decl0_148:i28.MatInputModule = (<any>(null as any));
var _decl0_149:i54.FlexLayoutModule = (<any>(null as any));
var _decl0_150:i31.MatMenuModule = (<any>(null as any));
var _decl0_151:i55.HttpClientModule = (<any>(null as any));
var _decl0_152:i32.RouterModule = (<any>(null as any));
var _decl0_153:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_154:i0.ElementRef = (<any>(null as any));
function _View_AppComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AppComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = 'true';
  currVal_1;
  const currVal_2:any = 'false';
  currVal_2;
  const currVal_3:any = _decl0_104.elements;
  currVal_3;
  const currVal_4:any = 'end';
  currVal_4;
  const currVal_5:any = '';
  currVal_5;
  const currVal_6:any = 'false';
  currVal_6;
  const currVal_7:any = 'true';
  currVal_7;
  const currVal_8:any = _any;
  currVal_8;
  const currVal_9:any = _decl0_104.elements;
  currVal_9;
  const pd_10:any = ((<any>_decl0_104.translatePage('en')) !== false);
  const pd_11:any = ((<any>_decl0_104.translatePage('ru')) !== false);
}
function _View_AboutComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_AboutComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_SysreqComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_SysreqComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.transform('sysreq');
  currVal_0;
  const currVal_1:any = _any.transform('minimal');
  currVal_1;
  const currVal_2:any = _any.transform('os');
  currVal_2;
  const currVal_3:any = _any.transform('os_min_val');
  currVal_3;
  const currVal_4:any = _any.transform('cpu');
  currVal_4;
  const currVal_5:any = _any.transform('cpu_min_val');
  currVal_5;
  const currVal_6:any = _any.transform('ram');
  currVal_6;
  const currVal_7:any = _any.transform('ram_min_val');
  currVal_7;
  const currVal_8:any = _any.transform('hdd');
  currVal_8;
  const currVal_9:any = _any.transform('hdd_min_val');
  currVal_9;
  const currVal_10:any = _any.transform('recommended');
  currVal_10;
  const currVal_11:any = _any.transform('os');
  currVal_11;
  const currVal_12:any = _any.transform('os_val');
  currVal_12;
  const currVal_13:any = _any.transform('cpu');
  currVal_13;
  const currVal_14:any = _any.transform('cpu_val');
  currVal_14;
  const currVal_15:any = _any.transform('ram');
  currVal_15;
  const currVal_16:any = _any.transform('ram_val');
  currVal_16;
  const currVal_17:any = _any.transform('hdd');
  currVal_17;
  const currVal_18:any = _any.transform('hdd_val');
  currVal_18;
}
function _View_AdminComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_AdminComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.transform('Keys');
  currVal_0;
  const currVal_1:any = _any.transform('Keys_desc');
  currVal_1;
}
function _View_PaypalComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_PaypalComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = _decl0_108.preparation;
  currVal_1;
  const currVal_2:any = (((_decl0_108.status == 'success') && !_decl0_108.proKey) && !_decl0_108.preparation);
  currVal_2;
  const currVal_3:any = (_decl0_108.status == 'error');
  currVal_3;
  const currVal_4:any = ((_decl0_108.status == 'success') && !_decl0_108.proKey);
  currVal_4;
  const currVal_5:any = ((_decl0_108.status == 'success') && !_decl0_108.proKey);
  currVal_5;
  const currVal_6:any = ((_decl0_108.status == 'success') && _decl0_108.proKey);
  currVal_6;
}
function _View_InvoicesComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_InvoicesComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_109.inv;
  currVal_0;
  const currVal_1:any = 40;
  currVal_1;
  const currVal_2:any = 'force';
  currVal_2;
  const currVal_3:any = 50;
  currVal_3;
  const currVal_4:any = 10;
  currVal_4;
  const currVal_5:any = 'Paid';
  currVal_5;
  const currVal_6:any = 'isPaid';
  currVal_6;
  const currVal_7:any = 'Invoice GUID';
  currVal_7;
  const currVal_8:any = 'invoiceGuid';
  currVal_8;
  const currVal_9:any = 'Number of PCs';
  currVal_9;
  const currVal_10:any = 'numberOfPcs';
  currVal_10;
  const currVal_11:any = 'Period';
  currVal_11;
  const currVal_12:any = 'period';
  currVal_12;
  const currVal_13:any = 'Amount';
  currVal_13;
  const currVal_14:any = 'amount';
  currVal_14;
  const currVal_15:any = 'Created';
  currVal_15;
  const currVal_16:any = 'created';
  currVal_16;
}
function _View_MapEditorComponent_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_MapEditorComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:boolean = !_decl0_110.mapCreationMode;
  currVal_0;
  const currVal_1:any = _decl0_110.mapCreationMode;
  currVal_1;
  const currVal_2:boolean = !_decl0_110.mapCreationMode;
  currVal_2;
}
function _View_KeysComponent_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_KeysComponent_8_0():void {
  var _any:any = (null as any);
  const currVal_0:boolean = !_decl0_111.keyCreationMode;
  currVal_0;
  const currVal_1:any = _decl0_111.keyCreationMode;
  currVal_1;
  const currVal_2:boolean = !_decl0_111.keyCreationMode;
  currVal_2;
}
function _View_GetZincComponent_Host_9_0():void {
  var _any:any = (null as any);
}
function _View_GetZincComponent_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'column';
  currVal_0;
  const currVal_1:any = '';
  currVal_1;
  const currVal_2:any = _any.transform('Download for windows pc');
  currVal_2;
  const currVal_3:any = _decl0_112.buttons;
  currVal_3;
  const currVal_4:any = _any.transform('download_descr');
  currVal_4;
  const currVal_5:any = '/features';
  currVal_5;
  const currVal_6:any = _any.transform('here');
  currVal_6;
  const currVal_7:any = 'column';
  currVal_7;
  const currVal_8:any = '';
  currVal_8;
  const currVal_9:any = _any.transform('regular_key');
  currVal_9;
  const currVal_10:any = _any.transform('buy_regular_key');
  currVal_10;
  const currVal_11:any = _any.transform('regular_key_descr');
  currVal_11;
  const currVal_12:any = _decl0_112.pricing.length;
  currVal_12;
  const pd_13:any = ((<any>_decl0_112.buy()) !== false);
}
function _View_NoContentComponent_Host_10_0():void {
  var _any:any = (null as any);
}
function _View_NoContentComponent_10_0():void {
  var _any:any = (null as any);
}
function _View_ChangelogComponent_Host_11_0():void {
  var _any:any = (null as any);
}
function _View_ChangelogComponent_11_0():void {
  var _any:any = (null as any);
}
function _View_MapsComponent_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_MapsComponent_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_115.nodeItems.length;
  currVal_0;
  const currVal_1:any = _decl0_115.selectedValue;
  currVal_1;
}
function _View_ProComponent_Host_13_0():void {
  var _any:any = (null as any);
}
function _View_ProComponent_13_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.transform('features');
  currVal_0;
  const currVal_1:any = _any.transform('features_table');
  currVal_1;
  const currVal_2:any = _any.transform('feature');
  currVal_2;
  const currVal_3:any = _any.transform('free');
  currVal_3;
  const currVal_4:any = _any.transform('regular_key');
  currVal_4;
  const currVal_5:any = _any.transform('pro_access');
  currVal_5;
  const currVal_6:any = _decl0_116.features;
  currVal_6;
}
function _View_LoginComponent_Host_14_0():void {
  var _any:any = (null as any);
}
function _View_LoginComponent_14_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_117.loginForm;
  currVal_0;
  const currVal_1:any = (<any>{'is-invalid':(_decl0_117.submitted && _decl0_117.f.username.errors)});
  currVal_1;
  const currVal_2:any = 'username';
  currVal_2;
  const currVal_3:any = 'login';
  currVal_3;
  const currVal_4:any = 'text';
  currVal_4;
  const currVal_5:any = (_decl0_117.submitted && _decl0_117.f.username.errors);
  currVal_5;
  const currVal_6:any = (<any>{'is-invalid':(_decl0_117.submitted && _decl0_117.f.password.errors)});
  currVal_6;
  const currVal_7:any = 'password';
  currVal_7;
  const currVal_8:any = 'password';
  currVal_8;
  const currVal_9:any = 'password';
  currVal_9;
  const currVal_10:any = (_decl0_117.submitted && _decl0_117.f.password.errors);
  currVal_10;
  const currVal_11:any = _decl0_117.loading;
  currVal_11;
  const currVal_12:any = _decl0_117.loading;
  currVal_12;
  const currVal_13:any = _decl0_117.error;
  currVal_13;
  const pd_14:any = ((<any>_decl0_117.onSubmit()) !== false);
}



// WEBPACK FOOTER //
// ./src/app/app.module.ngfactory.ts